// Copyright (c) 2016 Deere & Company

import OptionCode from '@deere/cps-it.warranty-model-factory/lib/option';
import t from 'tcomb';

const OptionCodes = t.list(OptionCode, 'OptionCodes');

export const getDefaultState = () => new OptionCodes([]);

export default OptionCodes;



// WEBPACK FOOTER //
// ./src/product/details/state/option-codes.js